import Translations from "@translate/components/QuickInsights/constants";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

// 视图状态枚举
export enum ViewState {
  RECOMMENDED = "recommended",
  SEARCH_OVERVIEW = "search_overview",
  CATEGORY_DETAIL = "category_detail",
}

// 分类类型枚举
export enum CategoryType {
  STOCKS = "stocks",
  CRYPTO = "crypto",
}

// 分类常量
export const CATEGORY_LIMITS = {
  [CategoryType.STOCKS]: 4,
  [CategoryType.CRYPTO]: 4,
};

export const CATEGORY_TITLES = {
  [CategoryType.STOCKS]: I18n.t("Stocks"),
  [CategoryType.CRYPTO]: I18n.t("Crypto"),
};

export const TAB_ITEMS = [
  {
    key: "us-stocks" as const,
    label: I18n.t("US Stock"),
  },
  {
    key: "hk-stocks" as const,
    label: I18n.t("HK Stock"),
  },
  {
    key: "crypto" as const,
    label: I18n.t("Crypto"),
  },
];
